import { renderSVG } from 'uqr';

function renderCarAppQr(wrapper) {
  const url = (wrapper.getAttribute('data-qr-url') || '').trim();
  const target = wrapper.querySelector('.single-car-app-qr-code');
  if (!url || !target) return;

  try {
    target.innerHTML = renderSVG(url, {
      ecc: 'M',
      border: 2,
      pixelSize: 4,
      blackColor: '#0C121C',
      whiteColor: '#ffffff',
    });

    const svg = target.querySelector('svg');
    if (svg) {
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('aria-hidden', 'true');
    }

    wrapper.hidden = false;
  } catch (error) {
    // Invalid/empty URLs should not break the rest of the page.
  }
}

function initCarAppQr() {
  document.querySelectorAll('[data-car-app-qr]').forEach(renderCarAppQr);
}

function isMobileDevice() {
  const ua = navigator.userAgent || navigator.vendor || '';
  return /Android|iPhone|iPad|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function initOfferButtonQrScroll() {
  document.addEventListener('click', (event) => {
    if (!event.target || typeof event.target.closest !== 'function') return;

    const trigger = event.target.closest(
      '[data-open-in-app][data-open-in-app-context="offer_price"]',
    );
    if (!trigger || isMobileDevice()) return;

    const qr = document.querySelector('[data-car-app-qr]');
    if (!qr) return;

    event.preventDefault();
    const scrollTarget = qr.closest('.single-car-app-notice') || qr;
    const prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scrollTarget.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'center',
    });

    qr.classList.add('is-highlighted');
    window.setTimeout(() => {
      qr.classList.remove('is-highlighted');
    }, 1800);
  });
}

initOfferButtonQrScroll();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCarAppQr);
} else {
  initCarAppQr();
}
